export default {
  carriers: [],
  carrier: {}
}



// WEBPACK FOOTER //
// ./src/components/carrier/store/state.js